// Override Settings
var boostPFSFilterConfig = {
	general: {
      limit: 50,
      /* Optional */
      loadProductFirst: false,
      // Product placeholder
      showPlaceholderProductList: true,
      placeholderImageRatio: 1, //It is used for ratio of image area  of Skeleton product item. (height / width)
      placeholderProductPerRow: 3,

      refineByStyle: 'style2',
      filterTreeMobileStyle: 'style1',
      activeLoadPreviousPage: true,
	  separateRefineByFromFilter: true,
      enableSeo: false,
	},
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;

// JP - 03/04/2021 - Added to keep track products when using the "master" tag
//var useCheckMaster = true;				// Turn on the "master" tag check feature or just show all the products
//var isUsingMasterTag = false;			// Checks to see if we are doing refinements and the specific ones that need to be ignored when looking for a "master" tag
//var totalCountWithMasterTag = 0;		// Count of items found with a "master" tag

// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml': '<div data-product-handle={{itemHandle}} id="{{itemHandle}}" class="grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemTagsLabel}} {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
								'<div class="grid-product__content">' +
									'{{itemLabel}}' +
									'<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
										'<div class="grid-product__image-mask">'+
											'{{itemQuickShopButton}}' +
											'{{itemImages}}'+
// 											'{{itemSwatchHoverImages}}' +
										'</div>' +
                                            '<div class="syte-badge" style="text-align: center; margin-top: .5rem">{{itemSyteInfo}}</div>' +  
										'<div class="grid-product__meta product-title-row" tabIndex="0">' +
											'{{itemVendor}}' +
											'<div class="grid-product__title product-title-column-left">{{itemTitle}}</div>' +
											'<div class="grid-product__price product-title-column-right">{{itemPrice}}</div>' +
										'</div>' +
									'</a>' +
								    '{{callouts}}' +
                                    '{{colorSwatch}}' +
                                    '{{ratingAndReviewsHtml}}' +
								'</div>' +
// 								'{{itemSwatch}}'+
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
	'previousDisabledHtml': '',
	'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
	'nextDisabledHtml': '',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">...</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="hidden-label">' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select" aria-role="select">{{sortingItems}}</select>',
};


(function () {
	/* This is to inject boost components into this scope, so we can override component's function */
	BoostPFS.inject(this);
	
	/************************** BUILD PRODUCT LIST **************************/

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
      	if (!index) index = this.index;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
      
      	// JP - 03/04/2021 - Determine if it's the master product
   	 	//var isMasterProduct = String(data.tags.find(s => s.startsWith("master"))) != 'undefined' ? true : false;
  
        // JP - 03/04/2021 - Checks to see if we are doing refinements and the specific ones that need to be ignored when looking for a "master" tag
        //isUsingMasterTag = useCheckMaster && 
        //  (!window.location.href.includes('?pf') || 
        //     ( 
        //        !window.location.href.includes('pf_t_color=') && 
        //        !window.location.href.includes('pf_opt_size=') && 
        //        !window.location.href.includes('pf_opt_shoe_size=') && 
        //        !window.location.href.includes('pf_opt_inseam=') && 
        //        !window.location.href.includes('pf_opt_waist=') && 
        //        !window.location.href.includes('pf_t_sleeve_length=')
        //     )
        //  );

      	var itemHtml = '';
        // JP - 03/04/2021 - Only continue if showing all or found a "master" tag
        // if (!useCheckMaster || (!isUsingMasterTag || (isUsingMasterTag && isMasterProduct))) {

            // Get Template
            itemHtml = boostPFSTemplate.productGridItemHtml;

            // Add Thumbnail
            var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
            var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
            var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
            var bgset = buildBgSet(thumb);
            var itemImagesHtml = '';
          
            var mainColor = String(data.tags.find(s => s.startsWith("RefColor:"))).replace("RefColor:", "");
          
            if(boostPFSConfig.custom.product_grid_image_size == 'natural'){
                itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">' +
                                    '<img ' +
                                        'class="grid-product__image lazyload" ' +
                                        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                                        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                                        'data-aspectratio="' + aspectRatio + '" ' +
                                        'data-sizes="auto" ' +
                  						'alt="{{itemTitle}} ' + mainColor + '">' +
                                '</div>';
            } else {
                itemImagesHtml += '<div ' +
                                    'class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + ' lazyload"' +
                                    'data-bgset="' + bgset +'"' +
					                'alt="{{itemTitle}} ' + mainColor + '" ' +
                                    'data-sizes="auto">' +
                                '</div>';
            }

            if (!soldOut) {
                if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
                    bgset = buildBgSet(images[1]);
                    itemImagesHtml += '<div ' +
                                        'class="grid-product__secondary-image small--hide lazyload"' +
                                        'data-bgset="' + bgset + '"' +
                      					'alt="{{itemTitle}} ' + mainColor + '" ' +
                                        'data-sizes="auto">' +
                                    '</div>';
                }
            }

          	itemImagesHtml = itemImagesHtml.replace(/{{itemTitle}}/g, data.title);
            itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
           // Syte information
            var itemSyteInfoHtml = '';
            itemSyteInfoHtml += '<button href="javascript:void(0)" class="syte-discovery syte-shopify-injected" data-placement="PLP" data-sku="{{itemId}}" data-image-src="'+ thumb.src + '" data-button-position="bottom_right" data-element-selector=".syte-badge">' +
                                '<!-- BEGIN app snippet: discovery-1 -->' +
                                '<svg class="discovery-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M22.2785 3.8987C22.2785 2.69627 21.3037 1.7215 20.1013 1.7215L16.0506 1.7215L16.0506 -3.47475e-07L20.1013 -1.70418e-07C22.2545 -7.62986e-08 24 1.74551 24 3.8987L24 7.9493L22.2785 7.9493L22.2785 3.8987Z" fill="#595959"></path>' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.72152 3.8987C1.72152 2.69627 2.69629 1.7215 3.89873 1.7215L7.94936 1.72151L7.94936 3.47478e-07L3.89873 1.70419e-07C1.74552 7.62992e-08 -7.62986e-08 1.74551 -1.70418e-07 3.8987L-3.47475e-07 7.9493L1.72152 7.9493L1.72152 3.8987Z" fill="#595959"></path>' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M20.1013 22.2785C21.3037 22.2785 22.2785 21.3037 22.2785 20.1013L22.2785 16.0507L24 16.0507L24 20.1013C24 22.2545 22.2545 24 20.1013 24L16.0506 24L16.0506 22.2785L20.1013 22.2785Z" fill="#595959"></path>' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.72152 20.1013C1.72152 21.3037 2.69629 22.2785 3.89873 22.2785L7.94936 22.2785L7.94936 24L3.89873 24C1.74552 24 2.28898e-07 22.2545 5.11257e-07 20.1013L1.04243e-06 16.0507L1.72152 16.0507L1.72152 20.1013Z" fill="#595959"></path>' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M14.4812 10.9874C14.4812 12.8329 12.9851 14.3291 11.1395 14.3291C9.29385 14.3291 7.79769 12.8329 7.79769 10.9874C7.79769 9.14176 9.29385 7.64561 11.1395 7.64561C12.9851 7.64561 14.4812 9.14176 14.4812 10.9874ZM14.0593 15.1244C13.2342 15.7078 12.2269 16.0506 11.1395 16.0506C8.34308 16.0506 6.07617 13.7837 6.07617 10.9874C6.07617 8.191 8.34308 5.9241 11.1395 5.9241C13.9358 5.9241 16.2027 8.191 16.2027 10.9874C16.2027 12.0747 15.86 13.082 15.2766 13.9071L18.8367 17.4672L17.6194 18.6845L14.0593 15.1244Z" fill="#595959"></path>' +
                                '</svg>' +
                                '<!-- END app snippet -->' +   
                                '<span class="button-text" style="margin-left: 10px;">Shop Similar</span>' +
                                '</button>';
            itemHtml = itemHtml.replace(/{{itemSyteInfo}}/g, itemSyteInfoHtml);

            // Add Price
            var itemPriceHtml = '';
            if (onSale) {
                itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
                //itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
                itemPriceHtml += '<span class="grid-product__price--original">' +  Utils.formatMoney(data.compare_at_price_min) + '</span>';

                //if (boostPFSConfig.general.collection_handle == 'sale') {             
                  itemPriceHtml += '<span class="grid-product__price--original grid-product__price--markdown" style="/* display:none */">' +  Utils.formatMoney((Math.round(data.price_min / 0.75))) + '</span>';
                  itemPriceHtml += '<span class="grid-product__price--original grid-product__price2" style="display:none;">' +  Utils.formatMoney(Math.round(data.price_min / 0.75)) + '</span>';
                //}
                itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
            }
            if (priceVaries) {
                itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
            } else {
                //itemPriceHtml += Utils.formatMoney(data.price_min);
	            itemPriceHtml += '<span class="grid-product__price--sale">' + Utils.formatMoney(data.price_min) + '</span>';
            }
            if (onSale && boostPFSConfig.custom.product_save_amount){
                var savePrice = '';
                if (boostPFSConfig.custom.product_save_type == 'dollar'){
                    savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
                } else {
                    savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
                    savePrice += '%';
                }
                var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);
	            itemPriceHtml += '<span class="grid-product__percent--sale">' + savePriceText + '</span>';
            }
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

            // Add soldOut class
            var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
            itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

            // Add label
            var customLabel = '';
            data.tags.forEach(function(tag){
                if (tag.startsWith('_label_')) {
                    if (!customLabel) {
                        customLabel = tag.replace('_label_', '');
                    }			
                }
            });
            var itemLabelHtml = '';
            if (customLabel){
                itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
            } else {
                // soldOut Label
                if (soldOut){
                    itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
                } else if (onSale){
                    itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale hide">' + boostPFSConfig.label.sale + '</div>';
                }	
            }
            itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

            // Add Vendor

            // NOTE: RD 08/23/2023 - Added in order to display Vendors OTHER THAN Cubavera. This is also altered on the product-template-master.liquid file near line 116
            var itemVendorHtml = boostPFSConfig.custom.vendor_enable && data.vendor != 'Cubavera' ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
            itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

            // Add Quick shop
            var itemQuickShopClass = '';
            var itemQuickShopButtonHtml = '';
            if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
                itemQuickShopClass = 'grid-product__has-quick-shop';
                itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
                                                '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
                                            '</div>';
            }
            itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
            itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

            // Add Reviews
            if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
                var reviewHtml = '';
                if(boostPFSConfig.custom.enable_product_reviews) {
                    reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
                }
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
            }

            // Color swatch
//             var swatchHtml = buildSwatch(data, this);
//           	console.log(swatchHtml);
//             itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
//             itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);
          
          	// PEI - Add Percentage
            //var itemPercentSaveHtml = '';
            //if (onSale && !soldOut) {
            //  itemPercentSaveHtml += '<span class="bc-sf-filter-product-item-savings">Save ' + data.percent_sale_min +'%</span></span>';
            //}
            //itemHtml = itemHtml.replace(/{{itemPercentSave}}/g, itemPercentSaveHtml);     
          
          	// PEI - ColorSwatch
            var colorSwatch = buildSwatch(data, this);
            itemHtml = itemHtml.replace(/{{colorSwatch}}/g, colorSwatch);

            // PEI - Add Tag Label
            itemHtml = itemHtml.replace(/{{itemTagsLabel}}/g, data.tags.join(" ").replace(/[^a-z0-9\s]/gi, ""));

            // PEI - Show the word "NEW!" in front of the title if the product contains the "Feature:New Arrival" tag
            var itemTitle = (String(data.tags.find(s => s.startsWith("Collection:New-Arrivals"))) != 'undefined' ? "<span class='new-product'>NEW! </span>" : "") + data.title;
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemTitle);

            // PEI - Product Ratings
            var ratingAndReviewsHtml = buildItemRatingAndReviews(data, this);
            itemHtml = itemHtml.replace(/{{ratingAndReviewsHtml}}/g, ratingAndReviewsHtml.itemRatingAndReviews); 

		    // PEI - Callouts should only be shown in the sale collection page - calloutPage is defined at the top of this file.
       		var callouts = '<span tabIndex="0" class="collection_callout1"></span><span tabIndex="0" class="collection_callout2"></span>';
			// if(boostPFSConfig.general.collection_handle == 'sale' || boostPFSConfig.general.collection_handle == `${calloutPage}`)
              	itemHtml = itemHtml.replace(/{{callouts}}/g, callouts);
      		//else
            //  itemHtml = itemHtml.replace(/{{callouts}}/g, '');
      
            // Add main attribute (Always put at the end of this function)
            itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
            itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
            itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
            itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
          
        //}

		return itemHtml;
	};
  
  	// PEI - Build Rating Section (JP - Added on 2020/11/10)
    function buildItemRatingAndReviews(data, _this) {

        var itemRatingAndReviewsHtml = '';
        var ratingItems = [];
        var ratingAndReviewsInfo = String(data.tags.find(s => s.startsWith("Rating:"))).replace("Rating:", "").split("|");

        if ( ratingAndReviewsInfo != 'undefined') {
            var ratingAverage = ratingAndReviewsInfo[0];
            var reviewCount = ratingAndReviewsInfo[1];

            // Do not show stars if the reviews are less than 3 stars
            if (ratingAverage < 2.75 )
              	return {
            		itemRatingAndReviews: itemRatingAndReviewsHtml
	        }; 
          
            if ( ratingAverage >= 1) {      		
                // Determine if no star, half a star, or full star
                var star1 = (ratingAverage >= .75) ? 'on' : ((ratingAverage % 1) >= .5 ? 'half' : '');
                var star2 = (ratingAverage >= 1.75) ? 'on' : ((ratingAverage > 1 && ratingAverage % 2) >= .275 && (ratingAverage > 1 && ratingAverage % 2) < .75 ? 'half' : '');
                var star3 = (ratingAverage >= 2.75) ? 'on' : ((ratingAverage > 2 && ratingAverage % 3) >= .275 && (ratingAverage > 2 && ratingAverage % 3) < .75 ? 'half' : '');
                var star4 = (ratingAverage >= 3.75) ? 'on' : ((ratingAverage > 3 && ratingAverage % 4) >= .275 && (ratingAverage > 3 && ratingAverage % 4) < .75 ? 'half' : '');
                var star5 = (ratingAverage >= 4.75) ? 'on' : ((ratingAverage > 4 && ratingAverage % 5) >= .275 && (ratingAverage > 4 && ratingAverage % 5) < .75 ? 'half' : '');

                itemRatingAndReviewsHtml = '<div class="collections-reviews">' +
                  								'<a href="{{itemUrl}}" class="pei-stars" role="link" tabIndex="0" aria-label="' + ratingAverage + ' star average rating"> ' +
                                                '<span class="pei-star ' + star1 + '"></span> ' +
                                                '<span class="pei-star ' + star2 + '"></span> ' +
                                                '<span class="pei-star ' + star3 + '"></span> ' +
                                                '<span class="pei-star ' + star4 + '"></span> ' +
                                                '<span class="pei-star ' + star5 + '"></span> ' +
                                              '</a> ' +
                  							  '<a href="{{itemUrl}}" class="pei-review" role="link" tabIndex="0" aria-label="' + reviewCount + ' reviews">(' + reviewCount + ')</a></div>' +
                                           '</div> ';
            }
        }

        return {
            itemRatingAndReviews: itemRatingAndReviewsHtml
        };
    }

    // PEI - Build Swatch
    function buildSwatch(data, ob) {
        var _this = ob;
        var itemSwatchHtml = '';
        if (boostPFSConfig.custom.collection_color_swatches) {
            var swatch_file_extension = 'png';
            var hexcolor_count = 0;
            var option_index = 0;
            itemSwatchHtml += '<div class="grid-product__colors grid-product__colors--' + data.id + '" >';

            // Get the hexadecimal color swatches
            var productGroup = String(data.tags.find(s => s.startsWith("ProductGroup:"))).replace("ProductGroup:", "");
            var hexColorSwatches = String(data.tags.find(s => s.startsWith("HexColorSwatches:"))).replace("HexColorSwatches:", "").split("-");
            var hexNameColorSwatches = String(data.tags.find(s => s.startsWith("HexNameColorSwatches:"))).replace("HexNameColorSwatches:", "").split("-");

            if ( hexColorSwatches != undefined && data.variants[0].sku != '') {

                // We found a list of hexadecimal color swatches
                hexcolor_count = hexColorSwatches.length;
                for (i = 0; i < hexColorSwatches.length; i++) {   

                  // Show the hexidecimal color swatch for the current product
                  var color_image = ''; 
                  var color_swatch_fallback = hexColorSwatches[i].toLowerCase();
                  var classImageSwatch = 'color-swatch--small color-swatch--' + color_swatch_fallback + ' ';
                  var ImageSwatch = 'swatches-for-handle' + color_swatch_fallback + ' ';
                  var attImage = '';
                  var classMultiColorImage = '';

                  // Use a background image as a swatch (if available), otherwise use the hex color of the product
                  if (!color_swatch_fallback.includes('#'))
                    classMultiColorImage =  'swatch-image-' + color_swatch_fallback.toLowerCase();

                  attImage += 'data-variant-id="' + data.id + '"';
                  attImage += 'data-variant-image="' + classMultiColorImage + '"';

                  // boostPFSConfig.general.collection_handle != 'sale' &&
                  if ( i > 3) {
                    itemSwatchHtml += '<a class="grid-product__title more-colors" aria-label="More Colors" href="https://' + location.hostname + '/collections/all/ProductGroup:' + productGroup + '?view=product-redirect&HexColor=' + Utils.encodeURIParamValue(color_swatch_fallback) + '&t=' + new Date().getTime() + '"' + attImage + ' rel="nofollow">More Colors</a>';
	                break;
                  }
                  else {
                    if (hexNameColorSwatches[i] != undefined)
                        itemSwatchHtml += '<a aria-label="Color ' + hexNameColorSwatches[i].toLowerCase() + '" role="img" id="swatch-' + i + '-{{itemHandle}}" href="https://' + location.hostname + '/collections/all/ProductGroup:' + productGroup + '?view=product-redirect&HexColor=' + Utils.encodeURIParamValue(color_swatch_fallback) + '&t=' + new Date().getTime() + '"' + attImage + ' rel="nofollow" class="color-swatch ' + classMultiColorImage + ' ' + classImageSwatch + '" style="background-color: ' + color_swatch_fallback + ';">';
                    else
                        itemSwatchHtml += '<a id="swatch-' + i + '-{{itemHandle}}" href="https://' + location.hostname + '/collections/all/ProductGroup:' + productGroup + '?view=product-redirect&HexColor=' + Utils.encodeURIParamValue(color_swatch_fallback) + '&t=' + new Date().getTime() + '"' + attImage + ' rel="nofollow" class="color-swatch ' + classMultiColorImage + ' ' + classImageSwatch + '" style="background-color: ' + color_swatch_fallback + ';">';
                    itemSwatchHtml += '</a>';
                  }
                }
            }

            itemSwatchHtml += '</div>';
            if (hexcolor_count < 2) {
                itemSwatchHtml += '<style>.grid-product__colors--' + data.id + ' {display: none;}</style>';
            }
        }
        return itemSwatchHtml;
    }

	function buildBgSet(image) {
		var html = '';
		if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
			var aspectRatio = image.width / image.height;
			if (image.width <= 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 360) html += Utils.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
			if (image.width > 540) html += Utils.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
			if (image.width > 720) html += Utils.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
			if (image.width > 900) html += Utils.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
			if (image.width > 1080) html += Utils.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
			if (image.width > 1296) html += Utils.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
			if (image.width > 1512) html += Utils.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
			if (image.width > 1728) html += Utils.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
		}
		return html;
	}
  

	/************************** END BUILD PRODUCT LIST **************************/
  
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		var paginationHtml = '';
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		
		if (totalPage > 1) {

			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
		return '';
	};

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		var sortingArr = Utils.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
			}
			html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
		}
		return html;
	};

	/* buildExtraProductList */
	ProductList.prototype.afterRender = function(data) {
		if (!data) {
			data = this.data;
		}

        /*
		if (typeof theme != 'undefined' &&
			typeof theme.reinitSection == 'function' &&
			typeof theme.collectionTemplate != 'undefined' &&
			typeof theme.collectionTemplate.reinit == 'function') {
			theme.reinitSection('collection-template');
			theme.collectionTemplate.reinit();
		}
        */

        // Start Boost 194203
        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        var localeURLPart = "";
    
        if (hasShopifyRoutes) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
            localeURLPart = "/" + boostPFSConfig.general.current_locale;
        }
      
        for (var i = 0; i < data.length; i++) {
              const prodId = data[i]['id'];
              quickUrl = localeURLPart + '/products/' + data[i].handle + '?view=boost-pfs-prod-prices';
              jQ.ajax({
                  url: quickUrl,
                  success: function(result) {
                      //console.log({result});
                      if (window.GLBE_PARAMS && window.GLBE_PARAMS.countryCode) {
                        if (window.GLBE_PARAMS.countryCode == "US")    
                          jQ('[data-id="' + prodId + '"]').find('.grid-product__price').html(result.trim().replaceAll('.00', ''));
                        else
                          jQ('[data-id="' + prodId + '"]').find('.grid-product__price').html(result.trim());                        
                      }
                      else
                        jQ('[data-id="' + prodId + '"]').find('.grid-product__price').html(result.trim());  
                  }
              });
          }
        // End Boost 194203
      
	};

	/* buildAdditionalElements */
	FilterResult.prototype.afterRender = function(data, eventType){
		if (!data) data = this.data;
      
		// Build total products text
		var totalProductText = '';
		if (data.total_product == 1) {
			totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
      
		jQ('.boost-pfs-filter-total-product').html(totalProductText);

		// Build filter button text on mobile
		var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
		if (numSelectedFilter){
			jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
			jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
		} else {
			jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
			jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
		}

      	// PEI - Don't show the count in the "Load More Products" button at the end of the pagination
		// jQ('.boost-pfs-filter-load-more-button').html(jQ('.boost-pfs-filter-load-more-button').html().replace(/[0-9]/g, ''));

        // PEI - Added addition "Start Over" button to allow the page to load back to page 1 - JP 06/21
        // This is to make sure that if user goes into the PDP page and clicks on "back" button, the user
        // has a chance to go back to the page 1 view since they won't be able to see past the current page
        // when scrolling up.
        var currentPage = Number.parseInt(getParameterByName('page'));  // "" (present with empty value)
        var currentPageURL = window.location.href.replace("page=" + currentPage.toString(), "page=1");
	
      	currentPage = (Number.isNaN(currentPage)) ? 1 : currentPage;
      
        if (!Number.isNaN(currentPage)) {
          if (currentPage > 2) {
              document.getElementById("divCollectionStartOver").style.display = "block";
              document.getElementById("lnkCollectionStartOver").href = currentPageURL;
          }
          else 
              document.getElementById("divCollectionStartOver").style.display = "none";
        }

        jQ('.boost-pfs-filter-total-product').html(totalProductText); 
        jQ('.boost-pfs-filter-total-product').attr("count", data.total_product);
        // else
        //   document.getElementById("divCollectionStartOver").style.display = "none";      

        if (!Globals.queryParams["pf_vl_stores"]) jQ('.boost-pfs-store-container .switch input').val('off');
          else jQ('.boost-pfs-store-container .switch input').val('on');
      
	};

    // Call theme init function
		//wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
		jQ(document).ready(function() {

            // Make contains case-Insensitive in JQuery in order to zero in on the "master"
            // jQ.expr[':'].Contains = function(a, i, m) {
            //   return jQuery(a).text().toUpperCase()
            //       .indexOf(m[3].toUpperCase()) >= 0;
            // };
          
            // PEI - Added to keep track of the count of products using the "master" tag
            //totalCountWithMasterTag = jQ('.boost-pfs-filter-option-value'). .boost-pfs-filter-option-amount').attr("data-count");
            //totalCountWithMasterTag = jQ(jQ('#boost-pfs-filter-tree2-pf-t-master span.boost-pfs-filter-option-value:Contains("MASTER")').siblings('.boost-pfs-filter-option-amount')[0]).text().replace(/[{()}]/g, '');
 

            // PEI - Check to see if we are only showing "master" products so that we don't show a higher product count
            //if (isUsingMasterTag) {
            //  jQ('.boost-pfs-filter-total-product').html(boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, totalCountWithMasterTag));
            //  jQ('.boost-pfs-filter-total-product').attr("count", totalCountWithMasterTag);
            //  //jQ('#bc-sf-filter-total-product').html("");
            //  
            //  var pagesToDisplay = Math.floor((Number.parseInt(totalCountWithMasterTag) / boostPFSFilterConfig.general.limit) / currentPage);
            //  if ( pagesToDisplay == 0 ) {
            //    jQ('.boost-pfs-filter-load-more').hide("");
            //  }
            //}
            //else {
            
              //jQ('#bc-sf-filter-total-product').show();
            //}
          
			if (typeof theme !== null && window.theme){
				// theme.collectionTemplate.reinit();
				AOS.refreshHard();

				// // Setup page transition classes
				// if (typeof theme.pageTransitions == 'function') theme.pageTransitions();

				// // Reload quick shop buttons
				// theme.initQuickShop(true);

				// // Reload products inside each quick shop
				// if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
				if (window.$ && typeof $ == 'function'){
					$(window).off('popstate');
				}
			}

          
			// Build quick view modals
			var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
			if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
				jQ('.boost-pfs-quick-shop-modal-container').html('');
				if (data.products.length > 0) {
					data.products.forEach(function(product){
						var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
						jQ.ajax({url: quickUrl, success: function(result) {
							numberQuickViewModalLoaded++;
							jQ('.boost-pfs-quick-shop-modal-container').append(result);
							if (numberQuickViewModalLoaded == data.products.length) {
								// theme.collectionTemplate.reinit();
								// AOS.refreshHard();

								// // Setup page transition classes
								// if (typeof theme.pageTransitions == 'function') theme.pageTransitions();

								// Reload quick shop buttons
								theme.initQuickShop(true);

								theme.collapsibles.init();

								// Reload products inside each quick shop
								//if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
								numberQuickViewModalLoaded = 0;
								jQ('.quick-product__btn').removeClass('bc-hide');
							}
						}});
					});
				}
			}

			if (isFirstLoad) {
				isFirstLoad = false;
			}

			// if (Utils.isInfiniteLoadingPaginationType() || Utils.isLoadMorePaginationType()) {
			// 	jQ('body').find('div.collection-filter').removeClass('collection-filter');
			// }

			jQ('.js-drawer-open-collection-filters').on('click', function(){
				jQ('.' + Class.filterOption).each(function() {
					var showMoreType = jQ(this).data('show-more-type');
					if (showMoreType && jQ(this).data('display-type') != 'range') {
						self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
					}
				});
			});
		});
  
	/* start-boost-custom */
    // #75381
    FilterApi.beforeCall = function(eventType, eventInfo) {
      /* Change the filter params before calling api */
      //console.log(eventInfo);
      var excludeData = ['pf_t_color','pf_opt_size','pf_opt_shoe_size','pf_opt_inseam','pf_opt_waist','pf_t_sleeve_length'];
      if(typeof(eventInfo) == "undefined"){
        if(Globals.queryParams['pf_t_color'] == null 
           && Globals.queryParams['pf_opt_size'] == null
           && Globals.queryParams['pf_opt_shoe_size'] == null
           && Globals.queryParams['pf_opt_inseam'] == null
           && Globals.queryParams['pf_opt_waist'] == null
           && Globals.queryParams['pf_t_sleeve_length'] == null){
          	Globals.queryParams['pf_t_master'] = ['Product:master'];
        }else{
        	Globals.queryParams['pf_t_master'] = null;
        }
      }else{
        if(Object.keys(eventInfo).length > 0){
          var filterValues = eventInfo.filterValues;
          var detectedExcludeData = false;
          if (filterValues) {
            for(var i = 0; i < filterValues.length; i++){
              if(excludeData.indexOf(filterValues[i]) !== -1){
                detectedExcludeData = true;
              }
            }
          }
          if(!detectedExcludeData){
            Globals.queryParams['pf_t_master'] = ['Product:master'];
          }else{
            Globals.queryParams['pf_t_master'] = null;
          }
        }else{
        	if(window.location.search.indexOf('pf_t_color') == -1 
               && window.location.search.indexOf('pf_opt_size') == -1
               && window.location.search.indexOf('pf_opt_shoe_size') == -1
               && window.location.search.indexOf('pf_opt_inseam') == -1
               && window.location.search.indexOf('pf_opt_waist') == -1
               && window.location.search.indexOf('pf_t_sleeve_length') == -1){
                Globals.queryParams['pf_t_master'] = ['Product:master'];
            }else{
              	console.log(eventInfo);
                Globals.queryParams['pf_t_master'] = null;
            }
        }
      }
    }

        FilterOptionItem.prototype.onApplyFilter = function() {
		var filterType = this.parent.filterType;
		var displayType = this.parent.displayType;
		var selectType = this.parent.selectType;
		var filterOptionId = this.parent.filterOptionId;
		var isEmptyAllCollection = this.handle == 'all' && this.docCount == 0 && filterType == FilterOptionEnum.FilterType.COLLECTION;

		if (this.docCount > 0 || this.parent.keepValuesStatic || displayType == FilterOptionEnum.DisplayType.RANGE || isEmptyAllCollection) {
			// This is action of clicking of user, not browser event
			Globals.internalClick = true;
			var eventType = '';

			// If filter by collection, set collectionId param, change address bar and window title
			if (filterType == FilterOptionEnum.FilterType.COLLECTION) {
				this.isSelected = true;
				Globals.collectionId = this.collectionId;
				FilterApi.setParam('collection_scope', this.collectionId);

				// If search page, adds pf_c_collection param
				if (Utils.isSearchPage()) {
					FilterApi.setParam(filterOptionId, this.collectionId);
				// If collection page, change collection URL
				} else {
					Navigation.setAddressBarPathAfterFilter('/collections/' + this.handle);
					Navigation.setWindowTitleAfterFilter(this.label + ' - ' + Globals.shopName);

					// Set new sort order on collection pages, and make it the default
					FilterApi.setParam('sort', this.sortOrder);
					Globals.defaultSorting = this.sortOrder;
				}

				// Clear all filter option params except collection
				var currentFilterOptionIds = [];
				Object.keys(Globals.queryParams).forEach(queryParam => {
					if (queryParam.startsWith(Globals.prefix) && !queryParam.startsWith(Globals.prefix  + '_c')) {
						currentFilterOptionIds.push(queryParam);
					}
				});

				currentFilterOptionIds.forEach(filterOptionId => {
					FilterApi.setParam(filterOptionId, null);
				});

				eventType = 'collection';
			
			// Else, set the filter option value(s)
			} else {

				// Toggle the selected state
				this.isSelected = !this.isSelected;

				// The values array to send to API
				var values = null;

				// If single option, set or clear the value based on selected state
				if (selectType == FilterOptionEnum.SelectType.SINGLE) {
					values = this.isSelected ? [this.value] : [];

				// If multiple option, remove or add the new value based on selected state
				} else {

					// Get existing value(s)
					values = Globals.queryParams[filterOptionId];
					if (!Array.isArray(values)){
						values = [];
					}

					if (this.isSelected) {
						// Add new value to existing values array
						if (!values.includes(this.value)) {
							values.push(this.value);
						}
                      	eventType = 'filter';
					} else {
						// Remove value from existing values array
						values = values.filter(x => x !== this.value);
                      	eventType = 'remove';
					}
				}
				FilterApi.setParam(filterOptionId, values);
				FilterApi.setParam(filterOptionId + '_and_condition', this.parent.useAndCondition && values.length > 0 ? true : null);
				FilterApi.setParam(filterOptionId + '_show_exact_rating', this.parent.showExactRating && values.length > 0 ? true : null);
				FilterApi.setParam(filterOptionId + '_exclude_from_value', this.parent.excludePriceFromValue && values.length > 0 ? true : null);
				
			}

			// Reset the page param
			FilterApi.setParam('page', 1);
          
          	// Custom add params to eventInfo
          	var selectedOptions = [];
          	Object.keys(Globals.queryParams).forEach(queryParam => {
                if (queryParam.startsWith(Globals.prefix) && !queryParam.startsWith(Globals.prefix  + '_c')) {
                  selectedOptions.push(queryParam);
                }
			});

			var eventInfo = {
				filterOptionId: filterOptionId,
				filterValue: this.value,
              	filterType: eventType,
              	filterValues: selectedOptions
			}
            
			FilterApi.applyFilter(eventType, eventInfo);
		}
	};
  
  	FilterClearButton.prototype.onClearAll = function() {
		var currentFilterOptionIds = [];
		Object.keys(Globals.queryParams).forEach(queryParam => {
			if (queryParam.startsWith(Globals.prefix)) {
				currentFilterOptionIds.push(queryParam);
			}
		});

		currentFilterOptionIds.forEach(filterOptionId => {
			FilterApi.setParam(filterOptionId, null);
		});
		FilterApi.setParam('page', 1);
		
		var eventType = 'clearAll';
		var eventInfo = {
        	filterValue: null,
          	filterType: eventType,
          	filterValues: []
        };
		FilterApi.applyFilter(eventType, eventInfo);
	}
  
  	FilterClearButton.prototype.onClearOptionValues = function() {
		// Close the tab on horizontal
		var filterOption = this.parent;
		if (filterOption.filterTreeType == FilterTreeEnum.FilterTreeType.HORIZONTAL && !Settings.getSettingValue('general.keepTabOpenState') && filterOption.collapse) {
			this.parent.collapse.onToggleHorizontal();
		}

		Globals.internalClick = true;

		var filterOptionId = filterOption.filterOptionId;
		// With multi collection on collection page, don't clear the collection, only clear the tags
		if (filterOption.displayType == FilterOptionEnum.DisplayType.MULTI_LEVEL_COLLECTIONS && !Utils.isSearchPage()) {
			filterOptionId = filterOptionId.replace(Globals.prefix + '_c_', Globals.prefix + '_ct_');
		}

		var eventType = 'clear';

      	// Custom add params to eventInfo
        var selectedOptions = [];
        Object.keys(Globals.queryParams).forEach(queryParam => {
          if (queryParam.startsWith(Globals.prefix) && !queryParam.startsWith(Globals.prefix  + '_c')) {
            if(filterOptionId !== queryParam){
            	selectedOptions.push(queryParam);
            }
          }
        });
      
        var eventInfo = {
          filterOptionId: filterOptionId,
          filterValue: null,
          filterType: eventType,
          filterValues: selectedOptions
        }
        
		FilterApi.setParam('page', 1);
		FilterApi.setParam(filterOptionId, null);
		FilterApi.setParam(filterOptionId + '_and_condition', null);
		FilterApi.setParam(filterOptionId + '_show_exact_rating', null);
		FilterApi.setParam(filterOptionId + '_exclude_from_value', null);
		FilterApi.applyFilter(eventType, eventInfo);
	}
    // end #75381
  	/* end-boost-custom */
    
	theme.preloadProductModal = function(handle, $btn) {
		var $holder = $('#QuickShopHolder-' + handle);
		var url = theme.routes.home + 'products/' + handle + '?view=modal';
		$holder.load(url + ' .product-section[data-product-handle='+handle+']', function() {
			// sections.register('product-template', theme.Product, $holder);
			$btn.removeClass('quick-product__btn--not-ready');
			AOS.refreshHard();
		});
	}

	/* If the quickview does not work, please try the solution below
		1. Add the class "grid-product" to the product item

		2. Change the theme code in FilterResults.prototype after render to only have this code:              theme.sections.reinit()              theme.initGlobals();              theme.initQuickShop();              theme.rteInit();

		3. Remove the code theme.preloadProductModal
	 */

    /* start-boost-custom */
    /* #boost-141165: implement custom filter */
    var currentStore;
    var currentStoreName;
    var hasStore = false;

    function initStoreSelector() {
      currentStore = localStorage.getItem('HC_CURRENT_STORE');
      currentStoreName = localStorage.getItem('HC_CURRENT_STORE_NAME');
      hasStore = currentStoreName && currentStoreName !== 'null' && currentStoreName !== 'undefined';

      if (hasStore) {
        jQ('.boost-pfs-store-current').text(currentStoreName)
        jQ('.boost-pfs-store-container').css('display', 'flex');
      } else {
        jQ('.boost-pfs-store-container').hide();
      }
    }

    function clearStoreFilter() {
      var eventInfo = {
          filterOptionId: 'pf_vl_stores'
      }

      FilterApi.setParam('page', 1);
      FilterApi.setParam(eventInfo.filterOptionId, null);
      FilterApi.setParam(eventInfo.filterOptionId + '_ibsl', null);
      FilterApi.applyFilter('clear', eventInfo);
    }

    function applyStoreFilter() {
      if (!currentStore) return
      
      var eventInfo = {
          filterOptionId: 'pf_vl_stores'
      }

      FilterApi.setParam('page', 1);
      FilterApi.setParam(eventInfo.filterOptionId, [currentStore]);
      FilterApi.setParam(eventInfo.filterOptionId + '_ibsl', 'true');
      FilterApi.applyFilter('filter', eventInfo);
    }

    initStoreSelector();

    jQ(document).on('click', '.hc-home-store-dropdown-button', function() {
      setTimeout(initStoreSelector, 200);
      var isSelected = jQ('.boost-pfs-store-container .switch input')[0].checked;
      if (isSelected) {
          jQ('.boost-pfs-store-container .switch input')[0].checked = false;
          clearStoreFilter();
      }
    });

    jQ(document).on('change', '.boost-pfs-store-container .switch input', function() {
      if (this.checked) applyStoreFilter();
      else clearStoreFilter();
    });
    
    jQ(document).ready(function() {
      if (Globals.queryParams.hasOwnProperty('pf_vl_stores') && Globals.queryParams.hasOwnProperty('pf_vl_stores_ibsl')) {
        jQ('.boost-pfs-store-container .switch input')[0].checked = true;
        //clearStoreFilter();
        applyStoreFilter();
      }
    });
  
})();


// PEI - Added to obtain the value of key/value pair in a querystring - JP 06/21
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}